import { api } from "./api";

/**
 * The account side of "connect an AI app to Husly" (the OAuth provider in
 * `apps/api/src/modules/oauth-provider`). Two pieces: the consent page reads and
 * answers one authorization request, and the Security section lists the apps the
 * person already allowed.
 */

/** What the consent page shows about one request. */
export interface ConsentRequest {
  /** Chosen by the app itself when it registered, so it proves nothing on its own. */
  clientName: string;
  clientWebsite: string | null;
  /** The host the person is sent back to: the one fact the app cannot fake. */
  redirectHost: string;
  scope: string;
}

export type ConsentRead =
  | { ok: true; request: ConsentRequest; user: { email: string; name: string } }
  | { ok: false; error: string; description: string; redirect?: string };

export interface AiConnection {
  id: string;
  appName: string;
  website: string | null;
  returnsTo: string | null;
  connectedAt: string;
  lastUsedAt: string | null;
}

export const consentApi = {
  /** `search` is the page's own query string (with its "?"), passed on unchanged. */
  read: (search: string) => api.get<ConsentRead>(`/oauth/authorize-request${search}`),
  /** Both answers come back as a place to send the browser. */
  answer: (query: Record<string, string>, allow: boolean) =>
    api.post<{ redirect: string }>("/oauth/authorize-request", { query, allow }),
};

export const aiConnectionsApi = {
  list: () => api.get<{ connections: AiConnection[] }>("/account/ai-connections").then((r) => r.connections),
  disconnect: (id: string) => api.del<void>(`/account/ai-connections/${encodeURIComponent(id)}`),
};
